import {
  vArray,
  vEmail,
  vLiteral,
  vMaxLength,
  vMinLength,
  vNonEmptyString,
  vObject,
  type vOutput,
  vPipe,
} from '../validation/index.ts'
import {
  ltlFlatLoadSchema,
  parcelFlatLoadSchema,
  tlFlatLoadSchema,
} from './flat-load/index.ts'

export const MAX_SHIPMENT_UPLOAD_COUNT = 500

export const maxShipmentUploadCountMessage = `Uploads are limited to ${MAX_SHIPMENT_UPLOAD_COUNT} shipments.`

export const shipmentUploadTruncatedMessage = `Your file contained more than ${MAX_SHIPMENT_UPLOAD_COUNT} shipments. Only the first ${MAX_SHIPMENT_UPLOAD_COUNT} were loaded.`

const shipmentUploadArraySchema = <
  const TSchema extends Parameters<typeof vArray>[0],
>(
  loadSchema: TSchema,
) =>
  vPipe(
    vArray(loadSchema),
    vMinLength(1),
    vMaxLength(MAX_SHIPMENT_UPLOAD_COUNT),
  )

export const baseShipmentUploadSchema = vObject({
  name: vNonEmptyString(),
})

export const ltlShipmentUploadSchema = vObject({
  ...baseShipmentUploadSchema.entries,
  workflow: vLiteral('ltl'),
  shipments: shipmentUploadArraySchema(ltlFlatLoadSchema),
})

export const parcelShipmentUploadSchema = vObject({
  ...baseShipmentUploadSchema.entries,
  workflow: vLiteral('parcel'),
  shipments: shipmentUploadArraySchema(parcelFlatLoadSchema),
})

export const tlShipmentUploadSchema = vObject({
  ...baseShipmentUploadSchema.entries,
  workflow: vLiteral('truckload'),
  spotQuoteRecipients: vArray(vEmail),
  shipments: shipmentUploadArraySchema(tlFlatLoadSchema),
})

export type LtlLoadUploadRequestDto = vOutput<typeof ltlShipmentUploadSchema>
export type ParcelLoadUploadRequestDto = vOutput<
  typeof parcelShipmentUploadSchema
>
export type TlLoadUploadRequestDto = vOutput<typeof tlShipmentUploadSchema>

export type LoadUploadRequestDto =
  | LtlLoadUploadRequestDto
  | ParcelLoadUploadRequestDto
  | TlLoadUploadRequestDto
